import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export const checkCPTCompatibility = (cpt: any, ndc: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.CHECK_NDC_CPT_COMPATIBILITY_REQUEST });

  return api.claim.ndc.checkCPTCompatibility(cpt, ndc)
    .then((res: any) => {

      dispatch({
        type: types.CHECK_NDC_CPT_COMPATIBILITY_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.CHECK_NDC_CPT_COMPATIBILITY_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const checkBulkCPTCompability = (array: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.CHECK_BULK_NDC_CPT_COMPATIBILITY_REQUEST });

  return api.claim.ndc.checkBulkCPTCompability(array)
    .then((res: any) => {

      dispatch({
        type: types.CHECK_BULK_NDC_CPT_COMPATIBILITY_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.CHECK_BULK_NDC_CPT_COMPATIBILITY_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getRelated = (cpt: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_RELATED_NDC_REQUEST });

  return api.claim.ndc.getRelated(cpt)
    .then((res: any) => {

      dispatch({
        type: types.GET_RELATED_NDC_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_RELATED_NDC_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getNdcCodes = (code: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_NDC_CODE_REQUEST });

  return api.claim.ndc.getNdcCodes(code)
    .then((res: any) => {

      dispatch({
        type: types.GET_NDC_CODE_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_NDC_CODE_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const checkIfNdcIsRequired = (cpt: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_NDC_REQUIRED_REQUEST });

  return api.claim.ndc.checkIfNdcIsRequired(cpt)
    .then((res: any) => {

      dispatch({
        type: types.GET_NDC_REQUIRED_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_NDC_REQUIRED_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
  